import axios from 'axios';
import  { useEffect, useState } from 'react'

function useDevo(selectedDate, isAlternative) {
  const [todayDevotional, setTodayDevotional] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect (() => {
    const fetchDevotionalData= async () => {
      setError(null);
      setLoading(true);
      try {
        const formattedDate = selectedDate.toISOString().slice(0, 10);
        const endpoint = isAlternative ? "https://cacityofgod.pythonanywhere.com/citizen/get_yoruba_breakfastwiththeholyspirit/" : "https://cacityofgod.pythonanywhere.com/citizen/get_breakfastwiththeholyspirit/";

        const response =await axios.get(endpoint)
        const devotionalData  = response.data
        const devotional = devotionalData.find((item) => item.date === formattedDate);
        setTodayDevotional(devotional || null);
    
      } catch (err) {
        setError("Error fetching devotional data");
        console.error("Error fetching devotional data:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchDevotionalData();
  }, [selectedDate, isAlternative]);

  return { todayDevotional, loading, error };

}

export default useDevo